import {
  defaultFetchOptions,
  _handleJsonResponse,
} from './DataExtraction/DataExtraction';
import { AUDIT_EVENTS_ROUTE, tokenizeRoute } from 'query/routes';

export type AuditEvent = {
  id: number;
  name: string;
  event_at: string;
  created_at: string;
  updated_at: string;
  reviewer_id: number | null;
  review_study_id: number;
  reviewer_name?: string;
  display_name: string;
  content: string | null;
  study_category: string | null;
};

export type AuditEventsResponse = {
  audit_events: AuditEvent[];
};

export const getAuditEvents = async (
  reviewId: number,
  studyId: number | string
): Promise<AuditEvent[]> => {
  if (!navigator.onLine) {
    throw new Error('No network connection detected');
  }

  const url = tokenizeRoute(AUDIT_EVENTS_ROUTE, {
    review_id: reviewId,
    study_id: studyId,
  });

  const response = await fetch(url.toString(), {
    method: 'GET',
    ...defaultFetchOptions(),
  });

  const data = await _handleJsonResponse(response);

  return Array.isArray(data) ? data : [];
};
